import { render, staticRenderFns } from "./viewIndicatorsRouter.vue?vue&type=template&id=70ea2e54&scoped=true"
import script from "./viewIndicatorsRouter.vue?vue&type=script&lang=js"
export * from "./viewIndicatorsRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea2e54",
  null
  
)

export default component.exports